import { render } from "./LocationFeature.vue?vue&type=template&id=5181b205&ts=true"
import script from "./LocationFeature.vue?vue&type=script&lang=ts"
export * from "./LocationFeature.vue?vue&type=script&lang=ts"

import "./LocationFeature.vue?vue&type=style&index=0&id=5181b205&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__